import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentsSearchText = createSelector(
  [(store: RootState) => store.locationShow.documentSearchText],
  (searchText) => searchText
);
